import { render, staticRenderFns } from "./BodyContent.vue?vue&type=template&id=5f6f39c5&"
import script from "./BodyContent.vue?vue&type=script&lang=js&"
export * from "./BodyContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports